// Module
var code = "<script>let $ctrl</script> <molecule-form-drop-down-revised disabled=\"$ctrl.disabled\" model=\"$ctrl.selectedOption\" options=\"$ctrl.items\" placeholder=\"{{ $ctrl.placeholder }}\" callback-on-change=\"$ctrl.callbackOnChange\"></molecule-form-drop-down-revised> ";
// Exports
module.exports = code;